import React from 'react';
import { Button } from './Button';

export function EmptyState({
  icon = 'fas fa-inbox',
  title = 'データがありません',
  description,
  actionLabel,
  onAction,
  className = '',
}) {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
      <div className="w-12 h-12 rounded-xl bg-prodia-background border border-prodia-border flex items-center justify-center mb-4">
        <i className={`${icon} text-prodia-text-muted text-lg`} aria-hidden="true" />
      </div>
      <p className="text-sm font-medium text-prodia-text-primary">{title}</p>
      {description && <p className="text-sm text-prodia-text-secondary mt-1 max-w-sm">{description}</p>}
      {actionLabel && onAction && (
        <Button variant="primary" size="sm" className="mt-4" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
